function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable */
import React, { forwardRef } from 'react';
/* Component */

import { jsx as ___EmotionJSX } from "@emotion/react";
export var withIconWrapper = function withIconWrapper(Component) {
  return /*#__PURE__*/forwardRef(function WrappedIcon(props, ref) {
    return ___EmotionJSX(Component, _extends({
      ref: ref
    }, props));
  });
};
//# sourceMappingURL=withIconWrapper.js.map